<template>
  <b-form-group :label-for="inputId" class="mt-3 mb-3" :class="labelClasses">
    <template #label>
      {{ inputLabel }}
    </template>
    <b-input-group>
      <b-form-input
        :id="inputId"
        type="text"
        v-model="query"
        autocomplete="off"
        @keydown.down="down"
        @keydown.up="up"
        @keydown.enter="hit"
        @keydown.esc="reset"
        @input="update"
        :readonly="readonly"
        :placeholder="inputPlaceHolder"
      />
      <template #append>
        <b-input-group-text v-if="loading">
          <b-spinner small label="Spinning"></b-spinner>
        </b-input-group-text>
      </template>
    </b-input-group>

    <ul v-show="hasItems" class="mt-1">
      <li
        v-for="(item, $item) in items"
        :key="item.id"
        :class="activeClass($item)"
        @mousedown="hit"
        @mousemove="setActive($item)"
      >
        <span v-if="item.categoriesId" class="name" v-text="'(' + item.categoriesId + ') ' + item[labelName]"></span>
        <span v-else class="name" v-text="item[labelName]"></span>      </li>
    </ul>
  </b-form-group>
</template>

<script>
import { debounce } from "vue-debounce";

export default {
  name: "gwzAutoComplete",
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    http: { type: Object },
    nameEndpoint: {
      type: String,
      default: "",
      required: true
    },
    labelName: {
      type: String,
      default: "name"
    },
    labelClasses: {
      type: String,
      default: ""
    },
    queryParamName: {
      type: String,
      default: "q"
    },
    inputLabel: {
      type: String,
      default: ""
    },
    inputPlaceHolder: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      items: [],
      query: "",
      current: -1,
      minChars: 2,
      loading: false,
      selectFirst: false
    };
  },
  computed: {
    hasItems() {
      return this.items.length > 0;
    }
  },
  watch: {
    readonly(bool) {
      if (bool) {
        this.reset();
      }
    }
  },
  methods: {
    update(payload) {
      if (!payload) {
        return this.reset();
      }
      this.query = payload;

      if (this.minChars && this.query.length < this.minChars) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.fetch();
    },
    fetch: debounce(function() {
      return this.http[this.nameEndpoint]({
        [this.queryParamName]: this.query
      }).then(res => {
        this.items = res.data["hydra:member"];
        this.loading = false;
      });
    }, 300),

    reset() {
      this.query = "";
      this.items = "";
    },
    setActive(index) {
      this.current = index;
    },
    activeClass(index) {
      return {
        active: this.current === index
      };
    },
    hit() {
      if (this.current !== -1) {
        this.onHit(this.items[this.current]);
      }
    },
    up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.items.length - 1;
      } else {
        this.current = -1;
      }
    },
    down() {
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },
    onHit(el) {
      this.$emit("update", el[this.labelName]);
      this.$emit("response", el);
      this.items = [];
    }
  },
  destroyed() {
    this.items = [];
  }
};
</script>

<style scoped>
i {
  float: right;
  position: relative;
  top: 27px;
  right: 29px;
  opacity: 0.4;
}

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: #fff;
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  z-index: 1000;
}

li {
  padding: 10px 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

li:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

li:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: 0;
}

span {
  display: block;
  color: #2c3e50;
}

.active {
  background-color: #287265;
}

.active span {
  color: white;
}

.name {
  font-weight: 700;
  font-size: 18px;
}
</style>
